// extracted by mini-css-extract-plugin
module.exports = {"container":"Link_container__2dycJ Div_Div__38Xlj","headline":"Link_headline__277ew","link":"Link_link__N_GWc"};